import ControlBarreras from '../../../../../../models/pesado/control_barreras'
import { TABLA_ACTIVIDAD_BARRERA_BRUTO } from '../../../../../../config/tables'
import { COLUMNS_ACTIVIDAD_BARRERA } from './constanteTablaActividadBarreraBruto'
import moment from 'moment'

export function parseData (motivos, registros) {
  const parsedData = []
  for (const entry of registros) {
    const motivo = motivos.find((m) => m.nombreCorto.trim() === entry.motivo.trim())
    parsedData.push({ ...entry, motivoActividad: motivo.nombre })
  }
  return parsedData
}

export function actualizarDatosParaMuiTable (fechaDesde, fechaHasta) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_ACTIVIDAD_BARRERA_BRUTO
    })

    const fechaD = moment(fechaDesde).format('YYYY-MM-DD')
    const fechaH = moment(fechaHasta).format('YYYY-MM-DD')

    Promise.all([
      ControlBarreras.getMotivosActividadBarreraBruto(),
      ControlBarreras.getRegistrosActividadBarreraBrutoEntreFechas(fechaD, fechaH)
    ]).then(([motivos, registros]) => {
      const data = parseData(motivos, registros)
      const customToolbar = null
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_ACTIVIDAD_BARRERA,
          data: data,
          title: 'Motivos de actividad en barrera de bruto',
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, pagination: false, search: false, download: false, tableBodyMaxHeight: '599px' }
        },
        id: TABLA_ACTIVIDAD_BARRERA_BRUTO
      })
    })
  }
}
